// eslint-disable-next-line import/prefer-default-export
export const LISTE_DEVIS = {
  title: 'List of quotes',
  actions: {
    filtre: 'Filter',
    newQuotation: 'New quote',
    drafts: 'Drafts',
    sent: 'Sent',
    accepted: 'Accepted',
    search: 'Search',
  },
  table: {
    numberQuotation: 'Quote n°',
    status: 'Statut',
    date: 'Date',
    customer: 'Customer',
    amountHt: 'Amount HT',
    amountTtc: 'Amout TTC',
  },
};
